/**
 * Looks up an element that the page is expected to contain, and fails loudly
 * if it does not — a missing hook is a markup bug, not something to paper over.
 */
export function requireById<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id)
  if (!el) throw new Error(`Expected an element with id "${id}" in the markup.`)
  return el as T
}
